export default function (state, {data, category}) {
    if (!data) return;
    state.CategoryId = category ? category : 0;
    state.Id = data.Id ? data.Id : -1;
    state.PaymentOperationID = data.PaymentOperationID ? data.PaymentOperationID : '';
    state.PaymentTypeId = data.PaymentTypeId ? data.PaymentTypeId : '';
    state.CashId = data.CashId ? data.CashId : '';
    state.PaymentAccountId = data.PaymentAccountId ? data.PaymentAccountId : '';
    state.AccountNumber = data.AccountNumber ? data.AccountNumber : '';
    state.Sum = data.Sum ? data.Sum : 0;
    state.BankCommission = data.BankCommission ? data.BankCommission : 0;
    state.PaymentDate = data.PaymentDate ? data.PaymentDate.Serialized : new Date().toStringRu();
    state.DocumentNumber = data.DocumentNumber ? data.DocumentNumber : '';
    state.Comment = data.Comment ? data.Comment : '';
    state.PaymentDetails = data.PaymentDetails ? data.PaymentDetails : [];
    state.loading = false;
}